module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_3009.a752979a.png";